import { red } from "@material-ui/core/colors";
import { emphasize } from "@material-ui/core/styles/colorManipulator";

const mediaStyle = {
  height: 0,
  paddingTop: "56.25%",
  borderBottom: "1px solid #ccc",
  position: "relative"
};

export default theme => ({
  container: {
    paddingLeft: 16,
    paddingRight: 16,
    display: "contents"
  },
  card: {
    overflow: "visible",
    width: "100%",
    marginBottom: "10%",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "30%"
    }
  },
  item: {
    fontSize: ".9rem"
  },
  tooltip: {
    fontSize: "0.85em",
    maxWidth: "100%",
    color: theme.palette.getContrastText(theme.palette.secondary.main),
    backgroundColor: theme.palette.primary.main
  },
  tooltipPlacementBottom: {
    margin: "-1.75rem 0"
  },
  popper: {
    opacity: 1
  },
  title: {
    fontSize: "1.1rem",
    [theme.breakpoints.up("sm")]: {
      height: "3.5rem"
    },
    display: "flex"
  },
  media: {
    ...mediaStyle
  },
  mediaLogo: {
    ...mediaStyle,
    backgroundSize: "auto"
  },
  descripcion: {},
  heartIcon: {
    position: "absolute",
    top: 10,
    right: 10,
    zIndex: 10,
    cursor: "pointer"
  },
  favContainer: {
    position: "relative"
  },
  score: {
    fontSize: ".8rem"
  },
  gridCard: {
    display: "flex",
    width: "100%",
    paddingLeft: "24px",
    paddingRight: "24px"
  },
  actionContainer: {
    justifyContent: "space-between",
    width: "100%",
    paddingLeft: "24px",
    paddingRight: "24px",
    "& a": {
      color: "inherit" /* blue colors for links too */,
      textDecoration: "inherit" /* no underline */,
      zIndex: 10
    },
    [theme.breakpoints.down("md")]: {
      paddingTop: 0
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "15px",
      paddingRight: "15px"
    }
  },
  imageActionContainer: {
    alignItems: "center",
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    paddingLeft: "24px",
    paddingRight: "24px",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "15px",
      paddingRight: "15px"
    }
  },
  imageUploadButton: {
    margin: theme.spacing.unit / 2,
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
      marginRight: 0,
      width: "100%"
    }
  },
  imageCaptureButton: {
    margin: theme.spacing.unit / 2,
    marginLeft: "auto",
    [theme.breakpoints.down("sm")]: {
      flexBasis: "100%",
      marginLeft: 0,
      marginRight: 0,
      width: "100%"
    }
  },
  link: {
    textDecoration: "none"
  },
  cardContent: {
    [theme.breakpoints.up("sm")]: {
      height: "9.5rem"
    },
    [theme.breakpoints.down("md")]: {
      paddingBottom: 0
    }
  },
  gridContainer: {
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto"
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    width: 960,
    maxWidth: "calc(100vw - 96px)",
    height: "calc(100vh - 96px)",
    maxHeight: 720,
    margin: 48,
    overflow: "hidden",
    position: "relative",
    boxSizing: "border-box",
    backgroundColor: theme.palette.common.black,
    overscrollBehavior: "contain",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: "100%",
      height: "100vh",
      maxHeight: "100vh",
      margin: 0,
      borderRadius: 0,
      "@supports (height: 100dvh)": {
        height: "100dvh",
        maxHeight: "100dvh"
      }
    }
  },
  cameraViewport: {
    flex: "1 1 auto",
    minHeight: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    padding: 0,
    boxSizing: "border-box",
    [theme.breakpoints.down("sm")]: {
      padding: 0
    }
  },
  webcam: {
    width: "100%",
    height: "100%",
    maxWidth: "100%",
    maxHeight: "100%",
    marginTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    objectFit: "contain",
    [theme.breakpoints.down("sm")]: {
      objectFit: "contain"
    }
  },
  cameraCloseButton: {
    position: "absolute",
    top: theme.spacing.unit,
    left: theme.spacing.unit,
    zIndex: 1,
    display: "inline-flex",
    width: 44,
    height: 44,
    color: theme.palette.common.white,
    backgroundColor: "rgba(0, 0, 0, 0.54)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.72)"
    },
    [theme.breakpoints.down("sm")]: {
      top: `calc(${theme.spacing.unit}px + env(safe-area-inset-top))`,
      left: theme.spacing.unit
    }
  },
  cameraActionContainer: {
    flexShrink: 0,
    position: "absolute",
    zIndex: 1,
    right: 0,
    bottom: 0,
    left: 0,
    alignItems: "center",
    justifyContent: "center",
    borderTop: 0,
    backgroundColor: "transparent",
    paddingTop: 0,
    paddingBottom: theme.spacing.unit,
    [theme.breakpoints.down("sm")]: {
      paddingBottom: `calc(${
        theme.spacing.unit
      }px + env(safe-area-inset-bottom))`
    }
  },
  cameraCancelButton: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  cameraCaptureTextButton: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  cameraCaptureButton: {
    display: "inline-flex",
    width: 56,
    height: 56,
    color: theme.palette.common.black,
    backgroundColor: theme.palette.common.white,
    border: "4px solid rgba(255, 255, 255, 0.55)",
    boxSizing: "border-box",
    touchAction: "manipulation",
    "&:hover": {
      backgroundColor: theme.palette.grey[100]
    },
    [theme.breakpoints.down("sm")]: {
      width: 64,
      height: 64,
      touchAction: "manipulation"
    }
  },
  formControl: {
    width: "100%"
  },
  chip: {
    margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
    height: "25px"
  },
  cancelChip: {
    fontSize: "20px"
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === "light"
        ? theme.palette.grey[300]
        : theme.palette.grey[700],
      0.08
    )
  },
  imagenCapture: {
    width: "100%",
    height: "auto",
    paddingLeft: "20px",
    paddingRight: "20px",
    marginTop: "10px",
    marginBottom: "10px"
  },
  progress: {
    alignSelf: "center",
    minHeight: 100
  }
});
